<template>
  <HXContentCard title="Nueva Sucursal" :toBack="{ name: 'Sucursales' }">
    <TourGuideLineal ref="tourGuide" />
    <form @submit.prevent="saveData">
      <div class="d-flex justify-content-end pt-4 pr-3">
        <vs-button id="startButton" v-b-tooltip.hover title="Iniciar tutorial" circle icon danger relief
          @click.prevent="startTour">
          <i class="far fa-circle-play mr-1"></i>
          Tutorial Rápido
        </vs-button>
      </div>
      <div class="row px-5 mt-4">
        <div class="col-md-6" id="nombreSucursal">
          <div>
            <label for=" " class="form-label">Nombre Sucursal</label>
            <input v-model="item.descripcion" required placeholder="Escriba el Nombre de la Sucursal..." type="text"
              class="form-control" id=" " />
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3" id="departamentoSucursal">
            <label for=" " class="form-label">Departamento/Estado</label>
            <b-form-select @change.native="actualizaDepto($event)" v-model="deptoSelected" required
              text-field="descripcion" value-field="id" :options="ListDepto">
              <template #first>
                <b-form-select-option v-if="selected == null" selected :value="none" disabled>-- Debes seleccionar un
                  país --</b-form-select-option>
                <b-form-select-option v-if="selected != null" selected :value="none" disabled>-- seleccionar
                  Departamento --</b-form-select-option>
              </template>
              <!-- <b-form-select-option ></b-form-select-option> -->
            </b-form-select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3" id="empresaSucursal">
            <label for=" " class="form-label">Empresa</label>
            <b-form-select :disabled="usuario.rol.nivel != 4 ? true : false" required v-model="item.EmpresaId"
              :options="ListEmpresas" text-field="nombre" value-field="id"></b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3" id="ciudadSucursal">
            <label for=" " class="form-label">Ciudad/Municipio</label>
            <b-form-select required v-model="item.MunicipioId" :options="ListMunicipios" text-field="descripcion"
              value-field="id">
              <template #first>
                <b-form-select-option selected :value="none" disabled>-- Seleccionar Ciudad/Municipio
                  --</b-form-select-option>
                <!-- <b-form-select-option v-if="selected!= null" selected :value="none" disabled>--  seleccionar Departamento --</b-form-select-option> -->
              </template>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-4" id="paisSucursal">
            <label for=" " class="form-label">País</label>
            <b-form-select v-model="selected" @change.native="actualizaPais($event)" required value-field="id"
              text-field="descripcion" :options="ListPais">
              <template #first>
                <b-form-select-option :value="none" disabled>-- Selecciona un país --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-4">
            <label for=" " class="form-label">Marca</label>
            <b-form-select v-model="item.MarcaId" value-field="id" text-field="descripcion" :options="ListMarcas">
              <template #first>
                <b-form-select-option selected :value="none" disabled>-- Selecciona una Marca --</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="text-right px-5 pb-4 d-flex justify-content-end" >
        <vs-button icon animation-type="vertical" type="submit" id="guardarSucursal">
          <i class="fas fa-save pr-1"></i>
          Guardar Sucursal
          <template #animate>
            <i class="fas fa-save"></i>
          </template>
        </vs-button>
      </div>
    </form>
  </HXContentCard>
</template>
<script>

// tour guide
import TourGuideLineal from "@/components/helexium/TourGuideLineal.vue";

export default {
  data() {
    return {
      item: { descripcion: "", EmpresaId: "", MunicipioId: "", MarcaId: null, Estado: 1 },
      ListPais: [],
      ListDepto: [],
      ListMunicipios: [],
      ListEmpresas: [],
      ListMarcas: [],
      pais: "",
      marca: "",
      depto: "",
      selected: null,
      deptoSelected: null,
      ciudadSelected: null,
      municipioSelected: null,
      MarcaSelected: null,
      empresaSelected: null,
      usuario: {},
      tourSteps: [
        {
          title: "Nombre Sucursal",
          description:
            "Ingresa un nombre representativo para la sucursal. Este campo debe permitir identificarla fácilmente dentro del sistema.",
          elementId: "nombreSucursal",
        },
        {
          title: "País Sucursal",
          description:
            "Indica el país donde se encuentra ubicada la sucursal. Esta información es necesaria para establecer parámetros regionales.",
          elementId: "paisSucursal",
        },
        {
          title: "Departamento/Estado Sucursal",
          description:
            "Selecciona el departamento o estado correspondiente a la ubicación de la sucursal dentro del país seleccionado.",
          elementId: "departamentoSucursal",
        },
        {
          title: "Ciudad/Municipio Sucursal",
          description:
            "Especifica la ciudad o municipio donde opera la sucursal. Esto permitirá un mayor nivel de detalle en la ubicación.",
          elementId: "ciudadSucursal",
        },
        {
          title: "Guardar Sucursal",
          description:
            "Por último, una vez diligenciada toda la información, deberás darle click en el botón de Guardar para finalizar.",
          elementId: "guardarSucursal",
        },
      ]

    };
  },

  components: {
    TourGuideLineal
  },

  async mounted() {
    this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));
    console.log("usuario ", this.usuario);
    this.item.EmpresaId = this.usuario.empresa.id;

    await this.getPais();
    await this.getMarca();
    await this.getEmpresas();

    console.log("Si habilitamos el tour?", this.$route.query.habilitarTour)
    if (this.$route.query.habilitarTour) {
      this.startTour()
    }
  },
  methods: {
    async actualizaDepto(e) {
      console.log(e.target.value);
      this.depto = e.target.value;
      await this.getMunicipio(this.depto);
    },
    async actualizaPais(e) {
      console.log(e.target.value);
      this.pais = e.target.value;
      await this.getDepartamento(this.pais);
    },
    async getEmpresas() {
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Empresa/ListEmpresa/",
        });
        this.ListEmpresas = res;

        console.log("list", this.ListEmpresas);
      } catch (error) {
        this.ListEmpresas = {};
        console.log("err", error);
      }
    },
    async getPais() {
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Pais/List/",
        });
        this.ListPais = res;

        console.log("list", this.ListPais);
      } catch (error) {
        this.ListPais = {};
        console.log("err", error);
      }
    },
    async getDepartamento(pais) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "DepartamentoPais/ListByPais/" + pais,
        });
        this.ListDepto = res;

        console.log("ListDepto", this.ListDepto);
      } catch (error) {
        this.ListDepto = {};
        console.log("err", error);
      }
    },
    async getMunicipio(departamentoId) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Municipio/ListByDepartamento/" + departamentoId,
        });
        this.ListMunicipios = res;

        console.log("ListDepto", this.ListDepto);
      } catch (error) {
        this.ListMunicipios = {};
        console.log("err", error);
      }
    },
    async getMarca() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Marca/GetMarca/" + this.usuario.empresa.id,
        });
        if (res.data && res.data.length > 0) {
          this.ListMarcas = res.data;
        } else {
          this.ListMarcas = [];
        }
      } catch (error) {
        this.ListMarcas = [];
        console.log("err", error);
      }
    },
    async saveData() {
      console.log("saving", this.item);
      try {
        let res = await this.$store.dispatch("hl_post", {
          path: "Sucursal/Create/",
          data: this.item,
        });
        console.log("post empresas...", res);
        if (res) this.$router.push("/helex/Sucursales");
        else alert("Verificar");
      } catch (error) {
        this.item = {};
        console.log("err", error);
      }
    },

    startTour() {
      this.$refs.tourGuide.startTour(
        this.tourSteps
      );
    },
  },
};
</script>
